/**
 * Pending session notes — supports common API field shapes.
 * Extend here when the backend documents the canonical flag.
 */
function sessionLooksCompleted(record: any): boolean {
  const s = String(record?.sessionStatus ?? "").toLowerCase();
  return /\b(complete|completed|done|attended|closed|finished)\b/.test(s);
}

export function isCompletedSession(record: any): boolean {
  if (record?.isCompleted === true) return true;
  if (record?.isCompleted === false) return false;
  return sessionLooksCompleted(record);
}

export function isPendingSessionNotes(record: any): boolean {
  const r = record as Record<string, unknown>;
  if (r.sessionNotesPending === true) return true;
  if (r.notesPending === true) return true;
  if (r.pendingSessionNotes === true) return true;
  if (r.requiresSessionNotes === true) return true;
  if (r.session_notes_status === "pending") return true;
  if (r.notesStatus === "pending") return true;
  if (r.sessionNotesComplete === false) return true;
  if (r.hasSessionNotes === false) return true;
  return false;
}

export function hasSessionNotesComplete(record: any): boolean {
  const r = record as Record<string, unknown>;
  if (r.sessionNotesComplete === true) return true;
  if (r.hasSessionNotes === true) return true;
  if (r.notesStatus === "complete" || r.session_notes_status === "complete")
    return true;
  return false;
}

export function sessionNotesBadge(
  record: any
): { label: string; tone: "pending" | "complete" | "neutral" } {
  if (isPendingSessionNotes(record))
    return { label: "Pending notes", tone: "pending" };
  if (hasSessionNotesComplete(record))
    return { label: "Notes complete", tone: "complete" };
  return { label: "—", tone: "neutral" };
}
